// PrivateRoutes.tsx

import React from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CheckoutPage from "../pages/Checkout/Checkout";

const PrivateRoutes: React.FC = () => {
  return (
    <div>
        <Routes>
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/" element={<Navigate to="/checkout" replace />} />
        </Routes>
      <ToastContainer />
    </div>
  );
};

export default PrivateRoutes;